// ─── Plan limits ──────────────────────────────────────────────────────────────

export const FREE_LIMITS = {
  flocks:           1,
  eggRecords:      20,
  sales:           10,
  expenses:        10,
  incubatorBatches: 1,
  inventory:        0,
};

export const GROWTH_LIMITS = {
  flocks:           5,
  eggRecords:       Infinity,
  sales:            Infinity,
  expenses:         Infinity,
  incubatorBatches: 3,
  inventory:        Infinity,
};

export const PRO_LIMITS = {
  flocks:           Infinity,
  eggRecords:       Infinity,
  sales:            Infinity,
  expenses:         Infinity,
  incubatorBatches: Infinity,
  inventory:        Infinity,
};

export const PLANS = {
  free:   { id: 'free',   name: 'Free',   limits: FREE_LIMITS   },
  growth: { id: 'growth', name: 'GROWTH', limits: GROWTH_LIMITS },
  pro:    { id: 'pro',    name: 'Pro',    limits: PRO_LIMITS    },
};

// ─── Pricing by country ───────────────────────────────────────────────────────
// pricing.growth / pricing.pro → { monthly, annual }
// annual = monthly × 12 × 0.75  (25% off)

export const COUNTRIES = [
  {
    code: 'IN', name: 'India',       flag: '🇮🇳', dialCode: '+91', currency: 'INR', symbol: '₹',
    pricing: { growth: { monthly: 499,    annual: 4490    }, pro: { monthly: 999,    annual: 8990    } },
  },
  {
    code: 'MY', name: 'Malaysia',    flag: '🇲🇾', dialCode: '+60', currency: 'MYR', symbol: 'RM',
    pricing: { growth: { monthly: 24,     annual: 216     }, pro: { monthly: 49,     annual: 440     } },
  },
  {
    code: 'TH', name: 'Thailand',    flag: '🇹🇭', dialCode: '+66', currency: 'THB', symbol: '฿',
    pricing: { growth: { monthly: 249,    annual: 2240    }, pro: { monthly: 499,    annual: 4490    } },
  },
  {
    code: 'ID', name: 'Indonesia',   flag: '🇮🇩', dialCode: '+62', currency: 'IDR', symbol: 'Rp',
    pricing: { growth: { monthly: 85000,  annual: 765000  }, pro: { monthly: 169000, annual: 1521000 } },
  },
  {
    code: 'SG', name: 'Singapore',   flag: '🇸🇬', dialCode: '+65', currency: 'SGD', symbol: 'S$',
    pricing: { growth: { monthly: 9,      annual: 81      }, pro: { monthly: 19,     annual: 171     } },
  },
  {
    code: 'PH', name: 'Philippines', flag: '🇵🇭', dialCode: '+63', currency: 'PHP', symbol: '₱',
    pricing: { growth: { monthly: 379,    annual: 3410    }, pro: { monthly: 749,    annual: 6740    } },
  },
  {
    code: 'OTHER', name: 'Other',    flag: '🌐', dialCode: '+1',  currency: 'USD', symbol: '$',
    pricing: { growth: { monthly: 6,      annual: 54      }, pro: { monthly: 12,     annual: 108     } },
  },
];

export function getCountry(code) {
  return COUNTRIES.find((c) => c.code === code) || COUNTRIES[COUNTRIES.length - 1];
}

/**
 * Format a price string.
 * plan: 'growth' | 'pro'
 * annual: boolean
 */
export function formatPrice(country, plan = 'pro', annual = false) {
  const c     = typeof country === 'string' ? getCountry(country) : country;
  const tier  = c.pricing[plan] || c.pricing.pro;
  const price = annual ? tier.annual : tier.monthly;
  const suffix = annual ? '/yr' : '/mo';
  // Currencies with no subdivision (IDR) or large numbers use spacing
  if (c.currency === 'IDR' || c.currency === 'PHP') {
    return `${c.symbol} ${price.toLocaleString()}${suffix}`;
  }
  return `${c.symbol}${price.toLocaleString()}${suffix}`;
}
